import { removeMark, setMarks, useEditorState } from '@udecode/plate';
import * as React from 'react';

import { ToolbarButton, ToolbarButtonProps } from '../toolbar-button';

export interface ToolbarMarkTextColorProps extends Omit<ToolbarButtonProps, 'active'> {
  type: string;
  icon: React.ReactNode;
  color: string;
  onClick?: () => void;
}

export const ToolbarMarkTextColor = ({
  type,
  icon,
  label,
  tooltip,
  color,
  onClick,
}: ToolbarMarkTextColorProps): JSX.Element => {
  const editor = useEditorState();
  const handleMouseDown = (e) => {
    e.preventDefault();
    if (color === 'Default') {
      removeMark(editor, { key: type });
    } else {
      setMarks(editor, { [type]: color });
    }

    onClick?.();
  };
  return (
    <ToolbarButton
      active={false}
      icon={icon}
      onMouseDown={handleMouseDown}
      label={label}
      tooltip={tooltip}
    />
  );
};
